export const copyToClipboard = async (str: string) => {
  if (navigator?.clipboard?.writeText) {
    try {
      return await navigator.clipboard.writeText(str);
    } catch {
      // Clipboard API can fail when document is not focused
    }
  }

  const textarea = document.createElement("textarea");
  textarea.value = str;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
};
